import {type AlgoTradeAccountInfo} from '../algo';

// eslint-disable-next-line @typescript-eslint/naming-convention
export type DBAlgoReport = {
  algo_type: string;
  status: string;
  algo_run_id: string;
  algo_run_auto_id: number;
  base_currency_iso_code: string;
  start_time_utc: string;
  end_time_utc: string;
  latest_status_time_utc: string;
  symbols: string;
  targetQTY: number;
  tradedQTY: string;
  remainingqty: string;
  pre_trade_tca_estimate_manual: number;
  pre_trade_tca_estimate_algo: number;
  run_cost: string;
  total_savings: string;
  trader: string;
  exchange: string;
  ccy: string;
  broker_code: string;
  trader_id: string;
  qep_account: string;
  bu_account: string;
  custom_text1: string;
  custom_text2: string;
  custom_text3: string;
  memo: string;
  duration_in_seconds: number;
  max_order_size_overall: number;
  created_time_utc: string;
  updated_time_utc: string;
  additional_parameters_raw_text: string;
  running_cost: number;
  value_fitted: number;
  value_fitted_gross: number;
  working_quantity_overall_gross: number;
  target_quantity_overall_gross: number;
  traded_quantity_overall_gross: number;
  remaining_quantity_overall_gross: number;
  execution_tag: string;
  external_account_code: string;
  internal_account_code: string;

};

// eslint-disable-next-line @typescript-eslint/naming-convention
export type DBAlgoTradeReport = {
  algo_trade_auto_id: number;
  algo_run_auto_id: number;
  segment_mic: string;
  qep_symbol: string;
  benchmark_price: number;
  launch_price: number;
  target_quantity: number;
  traded_quantity: number;
  average_fill_price: number;
  delta_benchmark: number;
  gamma_benchmark: number;
  vega_benchmark: number;
  theta_benchmark: number;
  fitted_vol_benchmark: number;
  broker_code: string;
  create_time_utc: string;
  updated_time_utc: string;
  ref_time_utc: string;
  algo_trade_status: string;
  details: string;
  currency_iso_code: string;
  bid_price: number;
  ask_price: number;
  last_mkt_trade_price: number;
  last_algo_trade_price: number;
  remaining_quantity: number;
  precent_time_passed: number;
  percent_complete: number;
  percent_ahead_or_behind: number;
  mid_price_at_trade_completion: number;
  mid_price_at_end_of_algo: number;
  base_ccy_running_cost: number;
  base_ccy_traded_slippage: number;
  base_ccy_remaining_moved_bid_ask: number;
} & AlgoTradeAccountInfo;

